"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.InlineObject10ToJSON = exports.InlineObject10FromJSONTyped = exports.InlineObject10FromJSON = void 0;
var _1 = require("./");
function InlineObject10FromJSON(json) {
    return InlineObject10FromJSONTyped(json, false);
}
exports.InlineObject10FromJSON = InlineObject10FromJSON;
function InlineObject10FromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'message': (0, _1.DiscordRelayMessageUpdateMessageFromJSON)(json['message']),
        'botToken': json['botToken'],
    };
}
exports.InlineObject10FromJSONTyped = InlineObject10FromJSONTyped;
function InlineObject10ToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'message': (0, _1.DiscordRelayMessageUpdateMessageToJSON)(value.message),
        'botToken': value.botToken,
    };
}
exports.InlineObject10ToJSON = InlineObject10ToJSON;
